<script>
import IconMixin from './IconMixin';

export default {
    mixins: [
        IconMixin
    ],
    data() {
        return {
            iconClass: 'list'
        }
    }
}
</script>
